import { useQuery } from 'react-query';
import GroupConfigurationAPI from 'services/API/GroupConfigurationAPI';

/** Query key for company leads in a group config. Use for invalidation after add/remove. */
export const companiesInCompanyGroupConfigQueryKey = (groupId: number, page?: number) =>
  page !== undefined
    ? ['companiesInCompanyGroupConfig', groupId, page]
    : ['companiesInCompanyGroupConfig', groupId];

export const useFetchCompanyLeads = (groupId: number, page: number = 1) => {
  return useQuery(
    companiesInCompanyGroupConfigQueryKey(groupId, page),
    async () => {
      const response = await GroupConfigurationAPI.getCompaniesForCompanyGroup(
        groupId,
        page,
      );

      return response?.data;
    },
    {
      enabled: !!groupId,
      refetchOnWindowFocus: false,
    },
  );
};
